/**
 * `heysegment doctor` — local environment and project setup diagnostics.
 *
 * This is intentionally local-only: it does not require a heysegment session or
 * network access. It catches the setup problems that make a valid pulled site
 * fail locally: wrong Node, ambiguous lockfiles, missing installs, pnpm build
 * approvals, and Astro/Vite mismatches.
 *
 * @module
 */
import { Command } from "effect/unstable/cli"
import { runDoctorProgram } from "../project-setup"
import { dirFlag, jsonFlag } from "./flags"

export const doctorCommand = Command.make(
  "doctor",
  { dir: dirFlag, json: jsonFlag },
  (flags) => runDoctorProgram({ dir: flags.dir, json: flags.json }),
).pipe(
  Command.withDescription(
    "Check Node, package manager, install state, session ignore rules, and common Astro/Vite issues",
  ),
)
